"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Retry = void 0;
const index_1 = require("../index");
const defaultOptions = {
    retryCodes: [401],
    retryDelay: 300,
    maxRetries: 3,
};
exports.Retry = (options = defaultOptions) => {
    options = Object.assign(Object.assign({}, defaultOptions), options);
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    function delayAsync(retryDelay) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => setTimeout(resolve, retryDelay));
        });
    }
    function retryAsync(originalMethod, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    args, retryCodes, retryDelay, maxRetries) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield originalMethod.apply(this, args);
            }
            catch (error) {
                const statusCode = ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) || 0;
                if (!retryCodes.includes(statusCode)) {
                    throw error;
                }
                if (maxRetries <= 0) {
                    throw error;
                }
                if (retryDelay) {
                    yield delayAsync(retryDelay);
                }
                /**
                 * Additional rules before retrying.
                 *
                 * @todo: Apply some behavioral design pattern if this gets more complex.
                 */
                switch (statusCode) {
                    case 401:
                        const accessToken = index_1.authService.getAccessToken();
                        if (accessToken) {
                            // reauth the user to set the newly created access token.
                            yield index_1.authService.reauthUser(accessToken, index_1.authService.getRefreshToken());
                            // delete the expired authorization bearer passed by the consumer.
                            if ((_c = (_b = args[1]) === null || _b === void 0 ? void 0 : _b.headers) === null || _c === void 0 ? void 0 : _c.authorization) {
                                delete args[1].headers.authorization;
                            }
                        }
                        else {
                            throw error;
                        }
                        break;
                }
                return retryAsync.apply(this, [originalMethod, args, retryCodes, retryDelay, maxRetries - 1]);
            }
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (target, propertyKey, descriptor) => {
        const originalMethod = descriptor.value;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        descriptor.value = function wrapper(...args) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    return yield retryAsync.apply(this, [
                        originalMethod,
                        args,
                        options.retryCodes,
                        options.retryDelay,
                        options.maxRetries,
                    ]);
                }
                catch (error) {
                    throw error;
                }
            });
        };
    };
};
